import { Row, Col, Alert, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface RequireLoginComponentProps {
  isNotAuthenticated: boolean;
  message?: string;
}

const RequireLoginComponent = ({ 
  isNotAuthenticated, 
  message = "You need to be logged in to view and edit clinical history." 
}: RequireLoginComponentProps) => {
  const navigate = useNavigate();

  if (!isNotAuthenticated) {
    return null;
  }

  return (
    <Row>
      <Col>
        <Alert variant="warning" className="mb-4">
          <Alert.Heading>Authentication Required</Alert.Heading>
          <p className="mb-3">{message}</p>
          <Button variant="primary" onClick={() => navigate("/login")}>
            Go to Login Page
          </Button>
        </Alert>
      </Col>
    </Row>
  );
};

export default RequireLoginComponent;

